module.exports = __webpack_public_path__ + "img/logo.11935e36.png";